import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import FileLoader from '../../../../components/Content/FileLoader';
import HtmlComponent from '../../../../components/Text/HtmlComponent';

const CmsBlockItem = ({ item, type, ...props }) => {
    if(item) {
        switch(type) {
            case 'link':
                return item.path ? (
                    item.path.indexOf('http') === 0
                    ? <a href={item.path} target="_blank" {...props}>{item.text}</a>
                    : <Link to={item.path} {...props}>{item.text}</Link>
                ) : null;
            case 'image':
                return <FileLoader key={item.sort} filename={item.path} hidePlaceholders alt={item.text} role="presentation" {...props} />;

            case 'html':
                return <HtmlComponent key={item.sort} text={item.text} {...props} />;
            case 'text':
            default:
                return <span key={item.sort} {...props}>{item.text}</span>;
        }
    }
    return null;
};

CmsBlockItem.defaultProps = {
    item: null,
    type: '',
};

CmsBlockItem.propTypes = {
    item: PropTypes.object,
    type: PropTypes.string,
};

export default CmsBlockItem;
